"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListResponseTemplateOut = void 0;
class ListResponseTemplateOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return ListResponseTemplateOut.attributeTypeMap;
    }
}
exports.ListResponseTemplateOut = ListResponseTemplateOut;
ListResponseTemplateOut.discriminator = undefined;
ListResponseTemplateOut.attributeTypeMap = [
    {
        "name": "data",
        "baseName": "data",
        "type": "Array<TemplateOut>",
        "format": ""
    },
    {
        "name": "done",
        "baseName": "done",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "iterator",
        "baseName": "iterator",
        "type": "string",
        "format": ""
    },
    {
        "name": "prevIterator",
        "baseName": "prevIterator",
        "type": "string",
        "format": ""
    }
];
//# sourceMappingURL=ListResponseTemplateOut.js.map